// @flow
import React from "react";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import { withStyles } from '@mui/styles';

const styles = {
  actionButton: {
    color: "inherit",
  },
  icon: {
    fontSize: 20,
  },
};

type Props = {
  onClose: Function,
  onAction?: Function,
};

function Action(props: Props) {
  const { onClose, onAction } = props;
  if (!onAction)
    return (
      <IconButton
        key="close"
        data-test="close"
        aria-label="Close"
        color="inherit"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    );
  return (
    <Button
      color="secondary"
      size="small"
      className={props.classes.actionButton}
      onClick={onAction}
    >
      {props.actionText || "redo"}
    </Button>
  );
}

export default withStyles(styles)(Action);
